import styles from './Message.module.scss';

export default function Message({children}) {
	return <div className={styles.messageBox}>{children}</div>;
}
